import { locale } from 'moment';
import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { first } from 'rxjs/operators';
import { BcAnalytics } from 'common/analytics/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { WindowService } from 'shared/services/window/window.service';
import { BcConfigService } from 'common/config/provider';
import { CoolLocalStorage } from '@angular-cool/storage';
import { MenuFocusParentDirective } from '../shared/menu-focus-handler';
import { Focusable } from 'shared/models/focus/focus.model';
import { Language } from 'environments/models/config.model';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LanguageSelectorComponent implements Focusable, OnInit {
  @ViewChild(MenuFocusParentDirective, { read: ElementRef })
  private focusParent: ElementRef;

  @Input()
  isFocusable?: boolean;

  language = '';
  currentLanguage = 'Language';
  languages: Language[] = [];
  preferredLanguageKey = 'bold360PreferredLanguage';
  fallbackLanguage = 'en-US';
  supportedLanguages = [];

  constructor(private translate: TranslateService,
              private config: BcConfigService,
              private bcAnalytics: BcAnalytics,
              private _window: WindowService,
              private _localStorage: CoolLocalStorage) {
  }

  ngOnInit(): void {
    this.supportedLanguages = this.config.current.supportedLanguages;
    this.languages = [...(this.config.current.languages)]
      .filter(lang => this.supportedLanguages.includes(lang.key));

    /* Set default language from Cookie */
    let storedLanguageKey = this._localStorage.getItem(this.preferredLanguageKey);

    if (!storedLanguageKey) {
      this._localStorage.setItem(this.preferredLanguageKey, this.fallbackLanguage);
      storedLanguageKey = this.fallbackLanguage;
    }
    const lang = this.config.current.languages.filter(value => value.key === storedLanguageKey);

    if (lang && lang.length > 0) {
      this.translate.use(storedLanguageKey);
      this.currentLanguage = lang[0].name;
      this.language = storedLanguageKey;
      locale(storedLanguageKey);
    } else {
      this.translate.use(this.fallbackLanguage);
    }
  }

  focus(): void {
    this.focusParent.nativeElement.focus();
  }

  setLanguage(language: Language): void {
    this._localStorage.setItem(this.preferredLanguageKey, language.key);

    this.translate.use(language.key).pipe(first()).subscribe({
      next: () => {
        this.bcAnalytics.eventTrack('LanguageChanged', { language });
        this._window.location.reload();
      },
      error: () => {
        this._localStorage.setItem(this.preferredLanguageKey, this.fallbackLanguage);
        this._window.location.reload();
      }
    });
  }
}
